import React, { Suspense, lazy } from 'react';
import SafeHtml from './SafeHtml';

/**
 * The rich-text editors, loaded when someone actually edits.
 *
 * TipTap and the ProseMirror packages under it are the largest thing in the
 * bundle — around 138 kB gzipped — and nothing needs them to open a lesson,
 * read one, or present it. Every renderer already chooses between the editor
 * and plain sanitized HTML on `isEditMode`; the editor was simply *imported*
 * eagerly, so it shipped to everyone regardless.
 *
 * The fallback is the block's own HTML in the same wrapper class the editor
 * renders into, so the text stays exactly where it is and becomes editable a
 * moment later — no spinner, no layout jump. After the first edit in a session
 * the chunk is cached and every later one is instant.
 *
 * Import the editors from here rather than directly: a single direct import
 * anywhere in the startup graph puts TipTap straight back into the initial
 * bundle, and the build still succeeds. `lazyEditors.test.js` guards that.
 */

const RichTextEditorImpl = lazy(() => import('../RichTextEditor'));
const HeadlineEditorImpl = lazy(() => import('../HeadlineEditor'));

// The loading states, named so they can be rendered on their own in a test —
// a Suspense fallback is otherwise gone too quickly to assert anything about.
// SafeHtml, not raw markup: block content is untrusted, and the loading moment
// is no exception.
export const RichTextEditorFallback = ({ content }) => (
  <SafeHtml className="rich-editor-content" html={content || ''} />
);

export const HeadlineEditorFallback = ({ content }) => (
  <SafeHtml className="headline-preview" html={content || ''} />
);

export const RichTextEditor = (props) => (
  <Suspense fallback={<RichTextEditorFallback content={props.content} />}>
    <RichTextEditorImpl {...props} />
  </Suspense>
);

export const HeadlineEditor = (props) => (
  <Suspense fallback={<HeadlineEditorFallback content={props.content} />}>
    <HeadlineEditorImpl {...props} />
  </Suspense>
);

export default RichTextEditor;
